import { render, staticRenderFns } from "./ListarAsignacionesFamiliares.vue?vue&type=template&id=641670ca&scoped=true&"
import script from "./ListarAsignacionesFamiliares.vue?vue&type=script&lang=js&"
export * from "./ListarAsignacionesFamiliares.vue?vue&type=script&lang=js&"
import style0 from "./ListarAsignacionesFamiliares.vue?vue&type=style&index=0&id=641670ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641670ca",
  null
  
)

export default component.exports